module.exports = __webpack_public_path__ + "img/ic_item_jk_default.367095bc.png";